{
  "version": 1,
  "asset_id": "fa07db09-f0f7-4019-a255-f72cbde303cc",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/fa07db09-f0f7-4019-a255-f72cbde303cc/bypass-revision-resection-es-800.webp",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/fa07db09-f0f7-4019-a255-f72cbde303cc/bypass-revision-resection-es-800.webp",
  "original_filename": "bypass-revision-resection-es-800.webp",
  "size": 83396,
  "content_type": "image/webp",
  "created_at": "2026-10-05T22:41:39Z"
}
